import axios from '@/api/axios';

const getStatuses = (tasks) => axios.post('/courier/statuses', tasks);

export default {
  getStatuses,
};
